module.exports = __webpack_public_path__ + "img/notification_important_outlined.357412ad.svg";